import React from "react";
import styled from "styled-components";
import ThemeButton from "./ThemeButton";

const StyledThemeToggle = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem;
`;

const ThemeToggle = (props) => {
  const handleClick = (name) => {
    props.changeTheme(name);
  };

  return (
    <StyledThemeToggle>
      <ThemeButton name={"main"} handleClick={handleClick} />
      <ThemeButton name={"dark"} handleClick={handleClick} />
      <ThemeButton name={"light"} handleClick={handleClick} />
    </StyledThemeToggle>
  );
};

export default ThemeToggle;
